import { type FunctionComponent } from 'react'
import { useTrackNavVersionDaily } from './useTrackNavVersionDaily'

// Headless component that fires a once-per-24h `app.navVersion.daily`
// tracking event capturing which nav version the user is rendering.
// Mounted in both PartnerScopedApp and AdminSection so every authenticated
// surface contributes to the daily snapshot.
export const NavVersionDailyTracker: FunctionComponent = () => {
  useTrackNavVersionDaily()
  return null
}
